import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain } from "../../../Base/helper/baseFunctions";

const currentYear = () => new Date().getFullYear().toString();
const currentMonth = () => (new Date().getMonth() + 1).toString();

export const GetPayrollSalaryPayoutHelper = async (params) => {
  return await axiosInstance(`/finance/ancillary/dashboard/getPayrollSalaryPayout`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      month: null,
      year: params?.year || +currentYear()
    }
  })
    .then((res) => ({
      message: "Payroll salary payout retrieved successfully",
      hasError: false,
      data: res?.data,
    }))
    .catch((err) => ({
      message: "Unable to retrieve payroll salary payout",
      hasError: true,
      data: err?.response?.data,
    }));
};

export const GetPayrollApveEmployeeHelper = async (params) => {
  return await axiosInstance(`/finance/ancillary/dashboard/getPayrollApve`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      month: null,
      year: params?.year || +currentYear()
    }
  })
    .then((res) => ({
      message: "Payroll apve retrieved successfully",
      hasError: false,
      data: res?.data,
    }))
    .catch((err) => ({
      message: "Unable to retrieve payroll apve",
      hasError: true,
      data: err?.response?.data,
    }));
};

export const GetPayrollIncentiveHelper = async (params) => {
  return await axiosInstance(`/finance/ancillary/dashboard/getPayrollIncentive`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      month: null,
      year: params?.year || +currentYear()
    }
  })
    .then((res) => ({
      message: "Payroll incentive retrieved successfully",
      hasError: false,
      data: res?.data,
    }))
    .catch((err) => ({
      message: "Unable to retrieve payroll incentive",
      hasError: true,
      data: err?.response?.data,
    }));
};
